/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import NotificationStore, { Subscription } from 'stores/NotificationStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import Loading from 'components/Loading/Loading';
import InfiniteLoader from 'components/InfiniteLoader';

import NotificationPanel from './NotificationPanel/NotificationPanel';
import styles from './Notifications.module.scss';

type InjectedProps = {
  notificationStore: NotificationStore,
} & TranslatorProps;

@translate()
@inject('notificationStore')
@observer
export default class ActionableNotifications extends ComponentWithInjectedProps<
  {},
  {},
  InjectedProps
> {
  @observable notificationsSubscription: ?Subscription;

  componentDidMount() {
    const { notificationStore } = this.props;

    this.notificationsSubscription = notificationStore.subscribeToNotifications(
      { type: 'actionable', urlParams: [], searchParams: [] },
      { background: false },
      true
    );
  }

  componentWillUnmount() {
    const { notificationStore } = this.props;

    if (this.notificationsSubscription) {
      notificationStore.unsubscribeFromNotifications(this.notificationsSubscription.id);
    }
  }

  handleRequestMoreItems = async () => {
    if (
      this.notificationsSubscription &&
      this.notificationsSubscription.pagesInView !== this.notificationsSubscription.nextPagesInView
    ) {
      await this.notificationsSubscription.setPagesInView(
        this.notificationsSubscription.nextPagesInView,
        true
      );
    }
  };

  renderNotification = (n: Object) => {
    const { notificationStore } = this.props;

    return (
      <NotificationPanel
        key={n.event_id}
        notification={n}
        handleAction={notificationStore.handleAction}
      />
    );
  };

  render() {
    const { t } = this.props;

    return (
      <InfiniteLoader
        onRequestMoreItems={this.handleRequestMoreItems}
        loading={!this.notificationsSubscription || this.notificationsSubscription.loading}
      >
        {!this.notificationsSubscription || !this.notificationsSubscription.data.length ? (
          <p className={styles.noResults}>
            {t('general:notifications.no_results.actionable_notifications')}
          </p>
        ) : (
          this.notificationsSubscription.data.map(this.renderNotification)
        )}
      </InfiniteLoader>
    );
  }
}
